import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const questions = [['¿Sirve si recién estoy arrancando como docente?', 'Sí. El Tomo 1 empieza desde los fundamentos y el recorrido avanza con rigor técnico graduado. Está pensado tanto para docentes que inician como para quienes buscan actualizar su material con contexto argentino.'], ['¿Cómo recibo el material?', 'Apenas se confirma el pago recibís un enlace de descarga directa. El acceso es inmediato y los PDFs están organizados para pantalla o impresión.'], ['¿El Upsell Premium es necesario?', 'El Megapack base reúne el sistema completo para enseñar. El Premium suma Petróleo y Gas Avanzado y Vaca Muerta y la Energía Argentina para profundizar EOR, offshore, IA, geología, controversias y escenarios futuros.'], ['¿Cuánto tiempo lleva implementarlo?', 'El primer día podés aplicar una actividad o una ficha técnica. La mayoría de los docentes incorpora cambios visibles en la primera semana.'], ['¿La garantía es real?', 'Sí. Dentro de los 7 días podés solicitar el reembolso del 100%, sin formularios interminables ni explicaciones.'], ['¿Aplica para cualquier nivel educativo?', 'Sí. Funciona para secundario técnico, terciario y formación docente con orientación en energía o industrias extractivas. También aporta a Geografía, Economía y Formación Ciudadana.'], ['¿Necesito conocimientos avanzados de petróleo y gas?', 'No. Cada tomo arranca desde lo conceptual y avanza hacia aplicaciones técnicas con ejemplos argentinos, analogías claras y actividades listas para usar.']];
export function FAQ() {
  const [open, setOpen] = useState(0);
  return <section className="bg-white py-20" aria-labelledby="faq-title" data-id="element-2">
      <div className="mx-auto max-w-3xl px-4" data-id="element-3">
        <p className="mb-3 text-center text-xs font-extrabold uppercase tracking-[.18em] text-earth" data-id="element-4">
          Resolvemos tus dudas
        </p>
        <h2 id="faq-title" className="text-balance text-center text-3xl font-extrabold text-forest-dark md:text-4xl" data-id="element-5">
          Preguntas frecuentes
        </h2>
        <div className="mt-10 space-y-3" data-id="element-6">
          {questions.map(([question, answer], index) => {
          const isOpen = index === open;
          return <article key={question} className="overflow-hidden rounded-2xl border border-sand bg-base" data-id="element-7">
                <h3 data-id="element-8">
                  <button className="flex w-full items-center justify-between gap-5 px-5 py-5 text-left font-bold text-forest-dark focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/40 sm:px-6" onClick={() => setOpen(isOpen ? -1 : index)} aria-expanded={isOpen} data-id="element-9">
                    {question}
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-earth transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-10" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-11">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2
              }} data-id="element-12">
                      <p className="border-t border-sand px-5 py-4 leading-relaxed text-muted sm:px-6" data-id="element-13">
                        {answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </article>;
        })}
        </div>
      </div>
    </section>;
}